import { useForm } from "react-hook-form";
import { GenericComponent } from "../../components/GenericComponent";
import { InfoAccionista } from "../../models/matriz/InfoAccionista";
import { InfoAccionistaService } from "../../service/matriz/InfoAccionistaService";
import { useEffect, useRef, useState } from "react";
import { InputComponent } from "../../components/InputComponent";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { DetalleAccionistaJuridicoDos } from "./DetalleAccionistaJuridicoDos";
import { Generico } from "../../components/Generico";
import { Busqueda } from "./Busqueda";
import { Button } from "primereact/button";
import { useToken } from "../../components/useToken";
import { PlantillaColor } from "./PlantillaColor";
import { TablaDinamica } from "../../components/TablaDinamica";
import { useLazyParams } from "../../hooks/useLazyParams";
import { Column } from "primereact/column";
import { Menu } from "primereact/menu";

export const AccionistaJuridico = () => {

    const [siEmpresa, setSiEmpresa] = useState(true);
    const [catalogo, setCatalogo] = useState(null);
    const omodel = new InfoAccionista({ formularioMatriz: catalogo?.formularioMatriz, siEmpresa });
    const generic = new GenericComponent();
    const { funcMessageBlobError, downloadPdf, limpiarNombre } = Generico();
    const accionistaSrv = new InfoAccionistaService();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const [permss, setPermss] = useState(null);
    const toast = useRef(null);
    const [dialogAccionista, setDialogAccionista] = useState(false);
    const [dialogPerfil, setDialogPerfil] = useState(false);
    const [dialogColor, setDialogColor] = useState(false);
    const [matriz, setMatriz] = useState(null);
    const { getRol } = useToken();
    const [opcion, setOpcion] = useState(null);
    const [dialogBusqueda, setDialogBusqueda] = useState(false);
    const [siFormulario, setSiFormulario] = useState(false);
    const { inText, inCalendar, inDrop } = InputComponent({ omodel, generic, errors, control, permss, id: getValues('id') });
    const tablaEstado = useLazyParams({ modelo: omodel.model });
    const menuRef = useRef(null);

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tablaEstado.lazyParams]);

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (opcion === 'PRELAFIT' || opcion.includes(strOpcion));
    }

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = 'permiso';
        }
        if (getRol()) {
            _lazyParams.rol = getRol();
        }
        accionistaSrv.lista({ lazyEvent: JSON.stringify(_lazyParams) }, 'j').then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            if (catalogo == null) {
                setCatalogo(res.data.catalogos);
                const _perms = res.data.perss;
                _perms.b1t = "Editar información inicial de matrices";
                _perms.b2t = "Editar / registrar detalles de información de matrices";
                _perms.b3t = "Eliminar información inicial de matrices";
                setPermss(res.data.perss);
                setOpcion(res.data.opcion);
                setSiEmpresa(res.data.opcion === 'PRELAFIT' || res.data.opcion.includes('RIESGO_CLIENTE-LISTA-EMPRESA'));
            }
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const openNew = () => {
        setSiFormulario(false);
        setMatriz(null);
        reset(defaultValues);
        setDialogAccionista(true);
    }

    const edit = () => {
        accionistaSrv.consultar(matriz?.id, 'j').then(res => {
            values(res.data);
        });
    }

    const values = (_accionista) => {
        setSiFormulario((typeof _accionista?.idp === 'number') || typeof matriz?.idp === 'number');
        const lista = { tipo_identificacion: catalogo?.tipo_identificacion };
        if (siOpcion('RIESGO_ACCIONISTA_JURIDICO-LISTA-EMPRESA')) {
            lista.empresa = catalogo?.empresas;
        } else {
            delete _accionista?.empresa;
        }
        Object.keys(lista).forEach(function (key) {
            if (_accionista[key] != null) {
                lista[key].forEach(element => {
                    if (element.cat_id === _accionista[key]) {
                        _accionista[key] = element;
                    }
                });
            }
        });
        _accionista.fecha = generic.stringToDate(_accionista.fecha);
        setMatriz(_accionista);

        reset(generic.renewValues(_accionista, omodel.model));
        setDialogAccionista(true);
    }

    const onSubmit = (data) => {
        if (matriz && matriz?.idp) {
            data.idp = matriz.idp;
        }
        data.fecha = generic.dateToString(data.fecha);
        delete data.fecha_nacimiento;
        if (getValues('id') == null) {
            accionistaSrv.nuevo(data, 'j').then(res => {
                generic.funcSuccess(res, toast);
                setDialogAccionista(false);
                tablaEstado.refreshData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        } else {
            accionistaSrv.editar(data, 'j').then(res => {
                generic.funcSuccess(res, toast);
                tablaEstado.refreshData();
                setDialogAccionista(false);
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const volverBorradorItem = (num, op) => {
        confirmDialog({
            message: `¿Está seguro de volver el análisis a ${num} año${num > 1 ? 's' : ''} a borrador?`,
            header: 'Confirmar',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-warning',
            acceptLabel: 'Sí',
            rejectLabel: 'No',
            accept: () => {
                accionistaSrv.volverBorrador({ id: matriz.id }, num, op).then(res => {
                    generic.funcSuccess(res, toast);
                    tablaEstado.refreshData();
                }).catch(error => {
                    generic.funcDeleteError(error, toast);
                });
            }
        });
    };

    const deleteItem = () => {
        confirmDialog({
            message: '¿Esta seguro de eliminar la matriz?',
            header: 'Confirmar',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Si',
            rejectLabel: 'No',
            accept: () => {
                accionistaSrv.eliminar(matriz?.id, 'j').then(res => {
                    generic.funcSuccess(res, toast);
                    tablaEstado.refreshData();
                }).catch(error => {
                    generic.funcDeleteError(error, toast);
                });
            }
        });
    }

    const generarReporte = () => {
        tablaEstado.setLoading(true);
        const nombreArchivo = `Matriz Accionista_PJ - ${limpiarNombre(matriz.nombres)}.pdf`;
        accionistaSrv.descargar(matriz?.id, 3, 'j').then(res => {
            downloadPdf(res, nombreArchivo);
        }).catch(error => {
            funcMessageBlobError('Asegúrese de ingresar y guardar la información antes de generar el reporte.', error, toast);
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && (!matriz?.nemonico || matriz?.nemonico !== 'FINALIZADO'))
            items.push({ label: 'Editar información de inicio', icon: 'pi pi-pencil', command: () => { edit() } });
        if (permss?.actualizar && (!matriz?.nemonico || matriz?.nemonico !== 'FINALIZADO'))
            items.push({ label: 'Contenido de la matriz', icon: 'pi pi-qrcode', command: () => { setDialogPerfil(true) } });
        if (permss?.consultar && matriz?.nemonico === 'FINALIZADO')
            items.push({ label: 'Imprimir matriz a PDF', icon: 'pi pi-print', command: () => { generarReporte() } });
        if (permss?.eliminar && (!matriz?.nemonico || matriz?.nemonico !== 'FINALIZADO'))
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { deleteItem() } });
        if (permss?.actualizar && matriz?.nemonico === 'FINALIZADO' && siOpcion('RIESGO_ACCIONISTA_JURIDICO-VOLVER-BORRADOR', permss?.actualizar)) {
            items.push({ label: 'A borrador (2 años)', icon: 'pi pi-history', command: () => { volverBorradorItem(2, 'n') } });
        }

        return [{ label: 'Opciones', items: items }];
    }

    const seleccionar = (data) => {
        values({ fecha: data?.fecha, nombres: data?.razon_social, identificacion: data?.identificacion, tipo_identificacion: data?.tipo_identificacion, idp: data?.id });
        setDialogBusqueda(false);
    }

    const startContent = (
        <>
            {permss?.crear && <Button icon="pi pi-plus" className="mr-2" tooltip="Nueva matriz" onClick={openNew} />}
            {siOpcion('RIESGO_ACCIONISTA_JURIDICO-BUSCAR-BVG') &&
                <Button icon="pi pi-search" className="mr-2" tooltip="Búsqueda Declaración Persona Jurídica: Accionista" onClick={() => setDialogBusqueda(true)} />}
            {siOpcion('RIESGO_ACCIONISTA_JURIDICO-COLORES') && <Button icon="pi pi-palette" className="mr-2" tooltip="Configuración de colores" onClick={() => setDialogColor(true)} />}
        </>
    );

    const regresar = () => {
        setMatriz(null);
        setDialogPerfil(false);
        tablaEstado.refreshData();
    }

    const accionesTemplate = (rowData) => {
        return (
            <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu" aria-haspopup
                onClick={(event) => { setMatriz(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '6rem', textAlign: 'center' }} />
    );

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            {!dialogPerfil && <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={startContent}
                    end={generic.rightToolbarTemplate(tablaEstado.data, omodel, 'Listado_matrices', 'LISTADO MATRICES')}></Toolbar>
                <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
            </Card>}

            <Dialog visible={dialogBusqueda} header='BÚSQUEDA - INFORMACIÓN DE PERSONAS JURÍDICA: Accionista' modal className="p-fluid modal-ssize"
                onHide={e => setDialogBusqueda(false)} style={{ maxWidth: '900px' }}>
                <Busqueda opcion="persona-juridica-accionista-bvg" permss={permss} toast={toast} seleccion={seleccionar} filtro={catalogo?.filtroMatriz} />
            </Dialog>

            <Dialog visible={dialogAccionista} header={getValues('id') == null ? "Nueva matriz" : "Editar matriz"} modal className="p-fluid modal-ssize"
                onHide={e => setDialogAccionista(false)} style={{ maxWidth: '500px' }}>
                <br />
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inCalendar('fecha', { disabled: siFormulario }, 12)}
                        {inDrop('tipo_identificacion', catalogo?.tipo_identificacion, { lab: omodel.optionLabel, ne: siFormulario }, 6)}
                        {inText('identificacion', { readOnly: siFormulario ? 'readOnly' : '' }, 6)}
                        {siOpcion('RIESGO_ACCIONISTA_JURIDICO-LISTA-EMPRESA') &&
                            inDrop('empresa', catalogo?.empresas, { lab: omodel.optionLabel, col: 6 }, 6)}
                        {inText('nombres', { readOnly: siFormulario ? 'readOnly' : '' }, 12)}
                    </div>

                    {generic.buttonsForms(setDialogAccionista)}
                </form>
            </Dialog>

            <Dialog visible={dialogColor} header="Colores" modal className="p-fluid modal-ssize dialog-personalizado"
                onHide={e => setDialogColor(false)} style={{ width: '800px' }}>
                <PlantillaColor generic={generic} permss={permss} toast={toast} catalogo={catalogo} funcionalidades={opcion} tipo={"RIESGO_ACCIONISTA_JURIDICO"} />
            </Dialog>

            {dialogPerfil && <DetalleAccionistaJuridicoDos matrizId={matriz?.id} permss={permss} setDialogPerfil={setDialogPerfil} toast={toast} regresar={regresar} funcionalidades={opcion} />}
        </>
    )
}
